// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_sectionHeader__a3czJ","sectionTitle":"SectionHeader_sectionTitle__JCU0u"};